import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { Spacing } from 'zens-storybook'
import { User } from 'zens-store'

import { titleForRole } from '@dms/helper'

import { InfoTable } from '../info'

const styles = StyleSheet.create({
  container: {
    marginBottom: Spacing.L,
  },
})

interface Props extends ViewProps {
  user: User
  companyId: number
}
const UserRoleInfo = (props: Props) => {
  const { user, companyId, style, ...otherProps } = props
  const { t } = useTranslation()
  const { roleId } = user
  // const location = useLocation({ companyId, locationId })

  const config = {
    fields: [
      // {
      //   label: t('Location access'),
      //   value: locationId ? location.data?.name : t('All locations'),
      // },
      {
        label: t('Role'),
        value: titleForRole(roleId, t),
      },
    ],
  }
  return (
    <View style={[styles.container, style]} {...otherProps}>
      <InfoTable
        companyId={companyId}
        config={config}
        buttonHref={`/companies/${companyId}/users/${user.id}/edit`}
        buttonTitle={t('Edit')}
      />
    </View>
  )
}

export default UserRoleInfo
